interface HeaderProps {
  left: React.ReactNode;
  middle: React.ReactNode;
  right: React.ReactNode;
}

export default function Header({ left, middle, right }: HeaderProps) {
  return (
    <div className='z-50 flex w-full flex-row gap-2 bg-white px-4 py-2 shadow-sm select-none'>
      <div className='flex basis-5/12 items-center'>{left}</div>
      <div className='flex basis-2/12 justify-center'>{middle}</div>
      <div className='flex basis-5/12 justify-end'>{right}</div>
    </div>
  );
}
